import {useState} from 'react';
export default function useDiscount() {

    const getDiscountModel = () => {
        try {
            const discountModel = JSON.parse(sessionStorage.getItem('discountModel'));
            return discountModel;
        }
        catch (ex){
            alert(Error);
            console.log("Error to get discount ", ex)
            return null;
        }
    };

    const [discountModel, setDiscountModel] = useState(getDiscountModel());

    const saveDiscountModel = (model) => {
        sessionStorage.setItem('discountModel', JSON.stringify(model));
        setDiscountModel(model);
    };

    return {
        saveDiscountModel: saveDiscountModel,
        //deleteToken: deleteToken,
        getDiscountModel: getDiscountModel,
        discountModel
    }
}